import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(180deg, #ffffff 80%, #000 20%);
  padding-top: 114px;
  @media (max-width: 568px) {
    padding-top: 40px;
  }

  .container {
    background-color: ${themeGet("colors.mainBlue")};
    display: flex;
    padding: 60px 90px;
    margin: 0px 30px;
    width: 100%;
    gap: 120px;

    @media only screen and (max-width: 1220px) {
      gap: 90px
    }
    @media only screen and (max-width: 990px) {
			padding: 30px 30px 50px;
			flex-direction: column;
      gap: 48px
    }

    .left-col {
      max-width: 448px;
			@media only screen and (max-width: 990px) {
			max-width: 100%;
    }

      .title {
        color: ${themeGet("colors.white")};
        font-weight: 400;
        font-size: 32px;
				margin-bottom: 0px;
      }
    }

    .button {
      background-color: ${themeGet("colors.white")};
      color: ${themeGet("colors.mainBlue")};
      font-size: 20px;
      border-radius: 0px;
      padding: 22px 28px;
      text-transform: capitalize;
      margin-top: 35px;
      margin-bottom: -10px;
      width: 200px
      &:hover {
        background-color: ${themeGet("colors.whiteHover")};
      }
      @media only screen and (max-width: 990px) {
				display: none;
				/* width: 100%;
        font-size: 18px; */
      }
    }

    .button-alt {
			display: none;
      @media only screen and (max-width: 990px) {
				display: block;
				background-color: ${themeGet("colors.white")};
      color: ${themeGet("colors.mainBlue")};
      font-size: 18px;
      border-radius: 0px;
      padding: 22px 28px;
      text-transform: capitalize;
      margin-top: 35px;
      margin-bottom: -10px;
      width: 100%;
      &:hover {
        background-color: ${themeGet("colors.whiteHover")};
      }
      }
    }

		.list-items {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 100%;

    	li {
				font-weight: 500;
				font-size: 20px;
				color: white;
				list-style-position: inside !important;
				list-style: disc;
				padding-left: 17px;
      text-indent: -30px;
				@media only screen and (max-width: 1220px) {
        margin-bottom: 12px;
      	}
				@media only screen and (max-width: 568px) {
        margin-bottom: 14px;
      	}
   		}
  	}
  }
`

export default Wrapper
